import clsx from 'clsx';

export const Input = (ps: {
  type?: 'text' | 'number';
  label?: string;
  value: string | number;
  onChange: (v: string | number) => void;
  required?: boolean;
  theme?: 'valid' | 'error' | 'warning' | 'scheduled';
  placeholder?: string;
}) => {
  return (
    <div className={'flex flex-col gap-2'}>
      {ps.label && (
        <label
          className={clsx(
            'text-sm',
            ps.theme === 'error' && 'text-red-500',
            ps.theme === 'warning' && 'text-yellow-500',
            ps.theme === 'valid' && 'text-green-500',
            !ps.theme && 'text-neutral-500',
          )}
          htmlFor={ps.label}>
          {ps.label}
          {ps.required && <span>*</span>}
        </label>
      )}
      <input
        id={ps.label}
        type={ps.type}
        className={clsx(
          'p-2 rounded-lg border-2 text-black outline-none',
          ps.theme === 'error' && 'border-red-500',
          ps.theme === 'warning' && 'border-yellow-500',
          ps.theme === 'valid' && 'border-green-500',
          !ps.theme && 'border-neutral-300',
        )}
        min={0}
        value={ps.value}
        placeholder={ps.placeholder}
        onChange={(e) => ps.onChange(e.target.value)}
      />
    </div>
  );
};
